<div class="page-title-area">
    <img src="assets/images/westpharma.png" alt="Page Background" class="page-bg">
    <div class="container">
        <div class="page-title-content">
            <h2>iPad & iPhone Deployment</h2>
            <!-- <ul>
                <li><a routerLink="/">Home </a></li>
                <li class="active">Case Studies Details</li>
            </ul> -->
        </div>
    </div>

    <!--   <div class="page-shape">
        <div class="shape1"><img src="assets/images/shape/1.png" alt="shape" /></div>
        <div class="shape3"><img src="assets/images/shape/3.png" alt="shape" /></div>
        <div class="shape4"><img src="assets/images/shape/4.png" alt="shape" /></div>
        <div class="shape5"><img src="assets/images/shape/5.png" alt="shape" /></div>
        <div class="shape6"><img src="assets/images/shape/6.png" alt="shape" /></div>
    </div> -->
</div>

<section class="services-details-area ptb-100">
    <div class="container">
        <!-- <div class="row">
            <div class="col-12">
                <div class="services-img mb">
                    <img src="assets/images/case-details/1.jpg" alt="Image">
                </div>
            </div>

            <div class="col-12">
                <div class="services-details-text">
                    <h2>Joe’s Company Software Development Case</h2>
                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum  not only five centuries, but also the leap into.</p>
                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc. this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a dictionary of over 200 Latin words, combined with a</p>
                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc generators on the Internet tend to repeat predefined chunks as necessary, making this the first generator dictionary of over 200 Latin words, combined with a.</p>
                </div>
            </div>
        </div> -->
       <!--  <div class="section-title">
            <div style="display: flex; flex-direction: row; text-align: center; justify-content: center;">
                <div><a href="https://www.westpharma.com/about-west" target="_blank">
                        <h2>iPad & iPhone Deployment &nbsp;</h2>
                    </a></div>
                <div style="margin-top: 4px;">
                    <a href="https://www.westpharma.com/about-west" target="_blank"><span
                            class="material-symbols-outlined" style="font-size: 35px; font-weight: 600;">
                            arrow_outward
                        </span></a>
                </div>
            </div>
        </div> -->

        <div class="scrives-item-2 mt-4 ">
            <div class="row align-items-center">
                <div class="col-12 col-md-6 d-flex justify-content-center align-items-center">
                    <div class="services-img mb-qc ios-content">
                        <div class="image-wrapper">
                          <!--   <div class="background-shape shape1"></div>
                            <div class="background-shape shape2"></div> -->
                            <img src="assets/images/solutions-details/24.png" alt="Person">
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <h3>About Customer</h3>
                    <p>This company is a global leader in the design and production of
                        advanced, high-quality containment and delivery systems for injectable
                        medicines. They are a trusted partner to leading pharmaceutical and
                        biotechnology firms, committed to improving patient health through innovative
                        solutions.</p>
                    <h3>Business Challenge</h3>
                    <p>The company aimed to enhance communication and
                        customer engagement by equipping its medical representatives and sales teams
                        with advanced mobile technology. The objective was to provide real-time data
                        access and streamline processes to improve sales interactions and productivity.</p>
                </div>
            </div>
        </div>

        <br>
        <br>

        <div class="scrives-item-2 mt-4 ">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <h3>Approach</h3>
                    <p>They adopted a strategy to deploy Apple mobile devices to its
                        sales teams and integrate them with mobile CRM applications to enhance their
                        operational efficiency and customer interaction capabilities.</p>
                    <h3>Usage</h3>
                    <p>They deployed over 200 iPads and 400 iPhones to its sales
                        teams. These devices were integrated with mobile CRM applications to track
                        customer interactions and sales performance. The devices provided easy access
                        to a comprehensive library of resources and product information, enabling more
                        informed discussions with clients.</p>
                </div>

                <div class="col-12 col-md-6 d-flex justify-content-center align-items-center">
                    <div class="services-img mb-qc ios-content">
                        <div class="image-wrapper">
                           <!--  <div class="background-shape shape1"></div>
                            <div class="background-shape shape2"></div> -->
                            <img src="assets/images/solutions-details/25.png" alt="Person">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <br>
        <br>

        <div class="scrives-item-2 mt-4 ">
            <div class="row align-items-center">
                <div class="col-12 col-md-6 d-flex justify-content-center align-items-center">
                    <div class="services-img mb-qc ios-content">
                        <div class="image-wrapper">
                            <!-- <div class="background-shape shape1"></div>
                            <div class="background-shape shape2"></div> -->
                            <img src="assets/images/solutions-details/38.png" alt="Person">
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <h3>Outcomes</h3>
                    <p>The introduction of iPads and iPhones led to a 30% increase in sales
                        interactions. The technology enhanced communication, improved workflows, and
                        increased the satisfaction levels of the sales teams. This strategic move set a
                        new standard for operations in the pharmaceutical industry.</p>
                    <h3>Apple and Partner solutions demonstrated</h3>

                    <p>Superior Digital partnered with this organization to supply 200 iPads and 400 iPhones, delivering a tailored solution
                        that included the right MDM platform, essential accessories, and expert deployment services. We ensured seamless
                        configuration and integration of the devices with organization's in-house apps, enabling secure, efficient, and
                        scalable enterprise mobility.</p>
                </div>
            </div>
        </div>

        <!-- <div class="scrives-item-3 mt-4">
            <div class="row align-items-center">
                <div class="col-lg-12">
                    <h3>Conclusion</h3>
                    <p>Essilor’s adoption of iPads highlights the importance of digital tools in modernising sales operations, ultimately enhancing customer engagement and business outcomes.</p>   
                </div>
            </div>
        </div> -->
        <br>
        <br>
        <span style="font-size: 14px; color: #f10909; text-align: center;">Disclaimer: Company names have been withheld
            due to copyright and legal approvals, but full details can be shared upon request.</span>
    </div>
</section>